import { LeadApi, LeadV1LeadListRequest, LeadV1ApproveLeadRequest } from '../mainApi/apis/LeadApi';
import { InlineResponse20014 } from '../mainApi/models/InlineResponse20014';
import { InlineResponse20015 } from '../mainApi/models/InlineResponse20015';
import { IResponse, requestMachine } from '../requestMachine';

export default {
  getLeads(variables: LeadV1LeadListRequest | undefined): Promise<IResponse<InlineResponse20014>> {
    return requestMachine<InlineResponse20014, LeadV1LeadListRequest>(LeadApi, 'leadV1LeadList', true, variables);
  },

  approveLead(variables: LeadV1ApproveLeadRequest): Promise<IResponse<InlineResponse20015>> {
    return requestMachine<InlineResponse20015, LeadV1ApproveLeadRequest>(LeadApi, 'leadV1ApproveLead', true, variables);
  },
};
